import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const _FilePlayer = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { type, ...props } = param;
    switch(type){
        case "video":
            return /*#__PURE__*/ _jsx("video", {
                ref: forwardedRef,
                ...props
            });
        case "audio":
            return /*#__PURE__*/ _jsx("audio", {
                ref: forwardedRef,
                ...props
            });
    }
});
_FilePlayer.displayName = "FilePlayer";
export const FilePlayer = /*#__PURE__*/ memo(_FilePlayer);
FilePlayer.displayName = "FilePlayer";
